export default __webpack_public_path__ + "static/blue_bg-9efc55ae444bf1beb576ddfd5d555cbf.png";